module.exports = __webpack_public_path__ + "static/blueprint-logo-5d5be8ee8d4376822b817e8e5891dfc6.png";